import { Component } from 'react';

export class UploadSVG extends Component<{ className?: string }> {
    render() {
        const { className } = this.props;
        return (
            <svg
                className={className}
                width="22"
                height="19"
                viewBox="0 0 22 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M21.2829 11.0718C20.8896 11.0718 20.5657 11.3954 20.5657 11.7883V17.567H1.43428V11.7883C1.43428 11.3954 1.11041 11.0718 0.71714 11.0718C0.32387 11.0718 0 11.3954 0 11.7883V18.2835C0 18.6765 0.32387 19.0001 0.71714 19.0001H21.2829C21.6761 19.0001 22 18.6765 22 18.2835V11.7883C22 11.3723 21.6761 11.0718 21.2829 11.0718Z"
                    fill="#0C2340"
                />
                <path
                    d="M7.26398 5.43192L10.2713 2.42703V13.1522C10.2713 13.5451 10.5952 13.8687 10.9885 13.8687C11.3818 13.8687 11.7056 13.5451 11.7056 13.1522V2.3808L14.7592 5.43192C15.0368 5.70929 15.4764 5.70929 15.754 5.43192C16.0316 5.15454 16.0316 4.71537 15.754 4.43799L11.5206 0.208031C11.3818 0.0693436 11.1967 0 11.0116 0C10.8265 0 10.6415 0.0693436 10.5027 0.208031L6.26924 4.43799C5.99163 4.71537 5.99163 5.15454 6.26924 5.43192C6.54684 5.70929 6.98638 5.70929 7.26398 5.43192Z"
                    fill="#0C2340"
                />
            </svg>
        );
    }
}
